// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-collapces[data-v-73258198]{display:flex;flex-wrap:wrap;grid-gap:var(--spaces-s)}@media(min-width:768px){.widget-collapces[data-v-73258198]{grid-gap:var(--spaces-m)}}.widget-collapces__item[data-v-73258198]{flex:1;min-width:170px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
